module.exports = __webpack_public_path__ + "static/media/facebook.47fc3c0c.svg";